module.exports = __webpack_public_path__ + "media/images/photo/about_girl-56fee34a7e09cc716cadc032f92fc8e3.png";